<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Multi Tracking" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Multi Tracking Detail - {{multi_tracking_detail.group_name}}
            .box__body
                .box-tabs
                    vue-tabs(
                        v-model="tabName"
                        @tab-change="handleTabChange"
                        ref="tabsRef"
                    )
                        v-tab(title="Meeting Point")
                            MeetingPoint

                        v-tab(title="Location History")
                            LocationHistory

                        v-tab(title="Monitoring History")
                            MonitoringHistory

</template>

<script>

import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import MeetingPoint from './../multi-tracking/detail/MeetingPoint.vue'
import LocationHistory from './../multi-tracking/detail/LocationHistory.vue'
import MonitoringHistory from './../multi-tracking/detail/MonitoringHistory.vue'
import {VueTabs, VTab} from 'vue-nav-tabs'

export default {
    name: 'PageMultiTrackingDetail',
    components: {
        HeaderGlobal,
        VueTabs,
        VTab,
        MeetingPoint,
        LocationHistory,
        MonitoringHistory,
    },
    data: function() {
        return {
            tabName: '',
        };
    },
    computed: {
        ...mapState([
            'multi_tracking_detail',

            // for open new tab
            'load_data_status_recent_location_es_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            // let page = {
            //     name: 'Meeting Point',
            //     url: '/multi-tracking/'+this.id+'/meeting-point',
            // };
            let page = {
                name: 'Multi Tracking Detail',
                url: '/multi-tracking/'+this.id+'/detail',
            };
            // if (this.route_name === 'MTLocationHistory')
            //     page = {
            //         name: 'Multi Tracking Detail',
            //         url: '/multi-tracking/'+this.id+'/detail',
            //         // name: 'Location History',
            //         // url: '/multi-tracking/'+this.id+'/location-history',
            //     };

            return [
                {
                    name: 'Multi Tracking',
                    url: '/multi-tracking',
                },
                page,
            ];
        }
    },
    methods : {
        getData() {
            this.$store.dispatch('getMultiTrackingDetail', [this.id])
            .then((resp) => {
                if (resp === 'success') {
                    console.log('success')
                } else {
                    this.error();
                }
            });
        },
        handleTabChange(tabIndex, newTab){
            // console.log('startMapLocationHistory', [tabIndex, newTab])
            if(newTab.title.toLowerCase() == 'location history' && this.load_data_status_recent_location_es_list !== 'loading')
                EventEmit.$emit('startMapLocationHistoryDetailMultitracking');
        },
    },
    mounted() {
        // console.log('=================== mounted on single target form')
        this.getData();
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageMultiTrackingDetail') {
                if (oldData !== 'PageMultiTrackingDetail') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setMultiTrackingDetail', {});
                }

                this.getData();
            }
        },
        // id() {
        //     if (this.id != undefined) {
        //         this.getData();
        //     }
        // },
    }
   
}
</script>

<style lang="sass">

</style>


